// 3rd party imports
import * as React from 'react';
import * as fetch from 'isomorphic-fetch';

//bernie
import { ContextStore, ExperimentStore, PageStore } from 'bernie-core';
import { ViewLarge, Viewport, ViewSmall } from 'bernie-view';

// uitk
import { ESSAdapter, TypeaheadSelection, UitkTypeahead } from 'uitk-react-typeahead';
import { UitkPrimaryButton } from 'uitk-react-button';
import { UitkTextArea, UitkTextInput } from 'uitk-react-input';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkToast } from 'uitk-react-toast';
import { UitkSelect } from 'uitk-react-select';
import { UitkStepInputProps } from 'uitk-react-step-input';
import { UitkSpacing, UitkSpacingHr } from 'uitk-react-spacing';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';

//utils
import { hasValidDateRange, isValidDateFormat } from '../../../../util/DatesUtil';

// components
import Loader from '../../common/loader';
import { ChildAgeComponent } from './childage-component';

export interface FlightExampleProps {
  // example: ExampleStore;
  context: ContextStore;
  logger?: Logger;
  page?: PageStore;
  experiment?: ExperimentStore;
  startDate?: Date;
  endDate?: Date;
}

export interface FlightExampleState {
  date: string;
  flightInfo: any;
  isHydrated: boolean;
  openVal: boolean;
}

const stepInputAttributes: UitkStepInputProps = {
  caption: 'Count',
  decreaseText: 'decrease',
  increaseText: 'increase',
  max: 17,
  min: 0,
  title: 'Adults ',
  value: 0,
};

export interface FlightTypeaheadSourceSelectionProps {
  data: FlightTypeaheadDataProps;
  term: string;
}

export interface FlightTypeaheadDestinationSelectionProps {
  data: FlightTypeaheadDataProps;
  term: string;
}

interface HierarchyInfo {
  airport: Airport;
}

interface Airport {
  airportCode: string;
  airportId: string;
  metrocode: string;
  multicity: string;
}

export interface FlightTypeaheadDataProps {
  regionId: string;
  originId: string;
  hierarchyInfo: HierarchyInfo;
  selectedSourceLocation: string;
  selectedDestinationLocation: string;
}

export class FlightLobSearch extends React.Component<any, any> {
  public onCloseRef;
  public constructor(props) {
    super(props);
    const startDate = new Date();
    this.state = { value: props.value };
    this.handleClick = this.handleClick.bind(this);
    this.handleUrlOpen = this.handleUrlOpen.bind(this);
    this.onChildAgeChange = this.onChildAgeChange.bind(this);
    this.onAdultCountChange = this.onAdultCountChange.bind(this);
    this.onAirlineChange = this.onAirlineChange.bind(this);
    this.onChildCountChange = this.onChildCountChange.bind(this);
    this.onDestinationLocationChange = this.onDestinationLocationChange.bind(this);
    this.onSourceLocationChange = this.onSourceLocationChange.bind(this);
    this.onFlightClassChange = this.onFlightClassChange.bind(this);
    this.onFlightDirects = this.onFlightDirects.bind(this);
    this.onFlightPenalty = this.onFlightPenalty.bind(this);
    this.onInfantCountChange = this.onInfantCountChange.bind(this);
    this.onSeniorCountChange = this.onSeniorCountChange.bind(this);
    this.onTriptypeDatehide = this.onTriptypeDatehide.bind(this);
    this.onTriptypeChange = this.onTriptypeChange.bind(this);
    this.copyToClipBoard = this.copyToClipBoard.bind(this);
    this.state = {
      startDate: '',
      endDate: '',
      triptype: 'roundtrip',
      preferredairline: 'N/A',
      flightclasschange: '3',
      flightdirectchange: '0',
      flightpenaltychange: '0',
      openVal: false,
      adultCount: '1',
      seniorCount: '0',
      infantCount: '0',
      numChild: '0',
      childId: '0',
      childAges: { childAge1: -1, childAge2: -1, childAge3: -1, childAge4: -1, childAge5: -1, childAge6: -1 },
      childComponent1: [],
      childComponent2: [],
      childComponent3: [],
      childComponent4: [],
      childComponent5: [],
      childComponent6: [],
      errors: { location: '', dates: '', infant: '' },
      error: false,
      message: '',
      copyStatus: false,
      isLoading: false,
      copyMessage: "Sorry! you don't have a deeplink to copy",
    };
  }

  public onChildAgeChange(event) {
    const { value } = event.target;
    const childAgeArray = this.state.childAges;
    const key = event.target.id;
    childAgeArray[key] = value;
    this.setState({
      childAges: childAgeArray,
    });
  }

  public onChildCountChange = (event) => {
    //const { value } = event.target.value
    //tslint:disable-next-line:no-console
    // console.log(value);
    const { value } = event.target;
    const childArray1 = this.state.childAges;
    const childArray = [];
    for (let i = Number(value) + 1; i <= 6; i++) {
      childArray1[`childAge${i}`] = -1;
    }
    this.setState({
      numChild: value,
      childAges: childArray1,
    });

    for (let i = 0; i < event.target.value; i++) {
      childArray.push(<ChildAgeComponent childNum={i + 1} onChildAgeChange={this.onChildAgeChange} />);
    }
    this.setState({
      childAge: childArray,
    });
  };

  public handleDatesChange = (event) => {
    const errors1 = this.state.errors;
    errors1['dates'] = '';
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  public validateDates(name: string) {
    const { startDate, endDate, triptype } = this.state;
    if ((!startDate && name === 'startDate') || (!endDate && name === 'endDate')) {
      return;
    }

    if (name === 'startDate' && !isValidDateFormat(startDate)) {
      return 'Please enter valid From date in the format mm/dd/yyyy';
    }
    if (name === 'endDate' && !isValidDateFormat(endDate)) {
      return 'Please enter valid To date in the format mm/dd/yyyy';
    }
  }

  public fetchData() {
    // tslint:disable-next-line:no-console
    const trip = this.state.triptype;
    const preferredAirline = this.state.preferredairline;
    const flightClassChange = this.state.flightclasschange;
    const flightDirectChange = this.state.flightdirectchange;
    const flightPenaltyChange = this.state.flightpenaltychange;
    const numSenior = this.state.seniorCount;
    const numinfants = this.state.infantCount;
    const source = this.state.selectedSourceLocation;
    const destination = this.state.selectedDestinationLocation;
    const mainCategory = 'Flights';
    const subCategory = 'flightSearch';
    const numAdult = this.state.adultCount;
    const numchild = this.state.numChild;
    const childage = this.state.childId;
    const checkInDate = this.state.startDate;
    let checkOutDate = this.state.endDate;
    if (checkOutDate === undefined || checkOutDate === '') {
      checkOutDate = checkInDate;
    }

    let param =
      `main-category=${mainCategory}&sub-category=${subCategory}&` +
      `flightSearch-TripType=${trip}&` +
      `flightSearch-FromAirport=${source}&` +
      `flightSearch-ToAirport=${destination}&` +
      `flightSearch-FromDate=${checkInDate}&flightSearch-ToDate=${checkOutDate}`;

    if (this.props.link.language) {
      param =
        param +
        `&flightSearch-marketingParam=clickid&flightSearch-marketingParamVal=&flightSearch-passthroughParam=langid&flightSearch-passthroughParamVal=${this.props.link.language}`;
    } else {
      param =
        param +
        `&flightSearch-marketingParam=clickid&flightSearch-marketingParamVal=&flightSearch-passthroughParam=langid&flightSearch-passthroughParamVal=1033`;
    }

    if (this.props.link.channel === 'Commission Junction') {
      if (this.props.link.pid || this.props.link.sid) {
        param = param + `&flightSearch-trackingParam=${this.props.link.channel}`;
      }
      if (this.props.link.pid && this.props.link.pid) {
        param = param + `&flightSearch-pid=${this.props.link.pid}`;
      }
      if (this.props.link.sid && this.props.link.sid) {
        param = param + `&flightSearch-sid=${this.props.link.sid}`;
      }
    }

    if (this.props.link.channel === 'PHG') {
      if (this.props.link.camRef || this.props.link.adRef || this.props.link.creativeRef || this.props.link.pubRef) {
        param = param + `&flightSearch-trackingParam=${this.props.link.channel}`;
      }
      if (this.props.link.camRef && this.props.link.camRef) {
        param = param + `&flightSearch-camref=${this.props.link.camRef}`;
      }
      if (this.props.link.adRef && this.props.link.adRef) {
        param = param + `&flightSearch-adref=${this.props.link.adRef}`;
      }
      if (this.props.link.creativeRef && this.props.link.creativeRef) {
        param = param + `&flightSearch-creativeref=${this.props.link.creativeRef}`;
      }
      if (this.props.link.pubRef && this.props.link.pubRef) {
        param = param + `&flightSearch-pubref=${this.props.link.pubRef}`;
      }
    }

    param =
      param +
      `&flightSearch-SearchType=Destination&` +
      'flightSearch-marketingParamVal=&flightSearch-passthroughParamVal=&' +
      `flightSearch-NumAdult=${numAdult}&flightSearch-NumChild=${numchild}&`;

    if (preferredAirline !== 'N/A') {
      param = param + `flightSearch-Airline=${preferredAirline}&`;
    }

    param =
      param +
      `flightSearch-Class=${flightClassChange}&` +
      `flightSearch-Direct=${flightDirectChange}&flightSearch-NoChangePenalty=${flightPenaltyChange}&` +
      `flightSearch-InfantInSeat=${numinfants}`;

    let child = '';
    if (this.state.numChild > 0) {
      const childArray1 = this.state.childAges;

      for (let i = 1; i <= this.state.numChild; i++) {
        const key = childArray1['childAge' + i];
        //const age = 'childAge'+i;
        //const key = childArray1.age;
        child = child + `&flightSearch-child${i}age=` + key;
      }
      /*if(this.state.childAges){
         let key = this.state.childAges.childAge1;
         child = child + `&flightSearch-child1age=`+key;
      }*/
    }

    if (child !== '') {
      param = param + child;
    }

    const url = `/api/paandi/marketing-tools/geturl?${param}`;

    return fetch(url, {
      method: 'GET',
    })
      .then((res) =>
        res.text().then((response) => {
          return response;
        }),
      )
      .catch((err) => ({
        error: err,
      }));
  }

  public handleClick() {
    let isError = false;
    const errors1 = this.state.errors;
    if (this.state.infantCount > this.state.adultCount) {
      isError = true;
      errors1['infant'] = 'Number of infants should be equal to number of adults';
    }
    if (
      this.state.selectedSourceLocation === '' ||
      this.state.selectedDestinationLocation === '' ||
      this.state.selectedSourceLocation === undefined ||
      this.state.selectedDestinationLocation === undefined
    ) {
      isError = true;
      errors1['location'] = 'Please enter Source and Destination';
    }
    if (
      this.state.startDate === undefined ||
      this.state.endDate === undefined ||
      this.state.startDate === '' ||
      (this.state.triptype === 'roundtrip' && this.state.endDate.length === 0)
    ) {
      isError = true;
      errors1['dates'] = 'Please enter your dates';
    }
    if (
      !!this.state.startDate &&
      !!this.state.endDate &&
      this.state.triptype === 'roundtrip' &&
      !hasValidDateRange(this.state.startDate, this.state.endDate)
    ) {
      isError = true;
      errors1['dates'] = 'Please enter valid dates';
    }
    this.setState({
      triptype: this.state.triptype,
      error: isError,
      errors: errors1,
      message: isError ? 'Form contains errors! Please correct it and proceed' : '',
    });
    if (!isError) {
      this.setState({
        isLoading: true,
      });
      this.fetchData().then((data) => {
        this.setState({
          link: data,
          isLoading: false,
          copyMessage: 'Successfully copied the deeplink to clipboard',
        });
      });
    } else {
      window.scrollTo(0, 0);
    }
  }

  public handleUrlOpen() {
    window.open(this.state.link);
  }

  public copyToClipBoard() {
    const textField = document.createElement('textarea');
    textField.innerText = this.state.link;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    this.setState({
      copyStatus: true,
    });
  }

  public onTriptypeDatehide() {
    if (this.state.triptype === 'roundtrip') {
      return (
        <div>
          <UitkSpacing padding={{ blockstart: 'three', blockend: 'three' }}>
            <UitkHeading tag="h2" size={5}>
              Select your Dates
            </UitkHeading>
          </UitkSpacing>
          <UitkLayoutFlex space="two">
            <>
              <UitkLayoutFlexItem minWidth="half_width">
                <div>
                  <UitkTextInput
                    id="startDate"
                    label="From Date"
                    placeholder="mm/dd/yyyy"
                    name="startDate"
                    value={this.state.startDate}
                    onChange={this.handleDatesChange}
                    invalid={this.validateDates('startDate')}
                    icon="today"
                  />
                </div>
              </UitkLayoutFlexItem>
              <UitkLayoutFlexItem minWidth="half_width">
                <div>
                  <UitkTextInput
                    id="endDate"
                    label="To Date"
                    placeholder="mm/dd/yyyy"
                    name="endDate"
                    value={this.state.endDate}
                    onChange={this.handleDatesChange}
                    invalid={this.validateDates('endDate')}
                    icon="today"
                  />
                </div>
              </UitkLayoutFlexItem>
            </>
          </UitkLayoutFlex>
        </div>
      );
    } else {
      return (
        <div>
          <UitkSpacing padding={{ blockstart: 'three', blockend: 'three' }}>
            <UitkHeading tag="h2" size={5}>
              Select your Dates
            </UitkHeading>
          </UitkSpacing>
          <UitkLayoutFlex space="two">
            <>
              <UitkLayoutFlexItem minWidth="full_width">
                <div>
                  <UitkTextInput
                    id="startDate"
                    label="From Date"
                    placeholder="mm/dd/yyyy"
                    name="startDate"
                    value={this.state.startDate}
                    onChange={this.handleDatesChange}
                    invalid={this.validateDates('startDate')}
                    icon="today"
                  />
                </div>
              </UitkLayoutFlexItem>
            </>
          </UitkLayoutFlex>
        </div>
      );
    }
  }

  public onSourceLocationChange = (selection: TypeaheadSelection) => {
    const errors1 = this.state.errors;
    errors1['location'] = '';
    this.setState({
      errors: errors1,
      message: '',
    });
    const { data, term } = selection as FlightTypeaheadSourceSelectionProps;
    // tslint:disable-next-line:no-console
    this.setState({ selectedSourceLocation: term });
  };

  public onDestinationLocationChange = (selection: TypeaheadSelection) => {
    const errors1 = this.state.errors;
    errors1['location'] = '';
    this.setState({
      errors: errors1,
      message: '',
    });
    const { data, term } = selection as FlightTypeaheadDestinationSelectionProps;
    // tslint:disable-next-line:no-console
    this.setState({ selectedDestinationLocation: term });
  };

  public onAirlineChange = (event) => {
    this.setState({ preferredairline: event.target.value });
  };

  public onTriptypeChange = (event) => {
    this.setState({ triptype: event.target.value });
  };

  public onFlightClassChange = (event) => {
    this.setState({ flightclasschange: event.target.value });
  };

  public onFlightDirects = (event) => {
    this.setState({ flightdirectchange: event.target.value });
  };

  public onFlightPenalty = (event) => {
    this.setState({ flightpenaltychange: event.target.value });
  };

  public onAdultCountChange = (event) => {
    this.setState({ adultCount: event.target.value });
  };

  public onSeniorCountChange = (event) => {
    this.setState({ seniorCount: event.target.value });
  };

  public onInfantCountChange = (event) => {
    const error1 = this.state.errors;
    error1['infant'] = '';
    this.setState({
      errors: error1,
    });
    this.setState({ infantCount: event.target.value });
  };

  public renderTripchange() {
    const triptype = [
      { key: 'roundtrip', value: 'Round Trip' },
      { key: 'oneway', value: 'One Way' },
    ];

    return triptype.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public renderPreferredAirline() {
    const preferredairline = [
      { key: 'N/A', value: 'N/A' },
      { key: 'A3', value: 'Aegean Airlines' },
      { key: 'EI', value: 'Aer Lingus' },
      { key: 'AR', value: 'Aerolineas Argentinas' },
      { key: 'AM', value: 'Aeromexico' },
      { key: 'VV', value: 'Aerosvit Airlines' },
      { key: 'AC', value: 'Air Canada' },
      { key: 'CA', value: 'Air China' },
      { key: 'AF', value: 'Air France' },
      { key: 'AI', value: 'Air India' },
      { key: 'JM', value: 'Air Jamaica' },
      { key: 'KM', value: 'Air Malta' },
      { key: 'NZ', value: 'Air New Zealand' },
      { key: 'AP', value: 'Air One' },
      { key: 'FJ', value: 'Air Pacific' },
      { key: 'TN', value: 'Air Tahiti Nui' },
      { key: 'TS', value: 'Air Transat' },
      { key: 'FL', value: 'AirTran Airways' },
      { key: 'AS', value: 'Alaska Airlines' },
      { key: 'AZ', value: 'Alitalia' },
      { key: 'NH', value: 'All Nippon Airways' },
      { key: 'AA', value: 'American Airlines' },
      { key: 'OZ', value: 'Asiana Airlines' },
      { key: 'OS', value: 'Austrian Airlines' },
      { key: 'BD', value: 'bmi' },
      { key: 'BA', value: 'British Airways' },
      { key: 'SN', value: 'Brussels Airlines' },
      { key: 'BW', value: 'Caribbean Airlines' },
      { key: 'CX', value: 'Cathay Pacific' },
      { key: 'KX', value: 'Cayman Airways' },
      { key: 'CI', value: 'China Airlines' },
      { key: 'CZ', value: 'China Southern Airlines' },
      { key: 'CO', value: 'Continental' },
      { key: 'CM', value: 'Copa' },
      { key: 'OK', value: 'Czech Airlines' },
      { key: 'DL', value: 'Delta' },
      { key: 'MS', value: ' Egyptair' },
      { key: 'LY', value: 'El Al' },
      { key: 'EK', value: 'Emirates' },
      { key: 'ET', value: 'Ethiopian Airlines' },
      { key: 'EY', value: 'Etihad Airways' },
      { key: 'GJ', value: 'Eurofly' },
      { key: 'BR', value: 'EVA Airways' },
      { key: 'XE', value: 'ExpressJet Airlines' },
      { key: 'AY', value: 'Finnair' },
      { key: 'F9', value: 'Frontier Airlines' },
      { key: 'GF', value: 'Gulf Air' },
      { key: 'HU', value: 'Hainan Air' },
      { key: 'HA', value: 'Hawaiian Airlines' },
      { key: 'IB', value: 'Iberia' },
      { key: 'FI', value: 'Icelandair' },
      { key: 'JL', value: 'Japan Airlines' },
      { key: '9W', value: 'Jet Airways' },
      { key: 'b6', value: 'JetBlue Airways' },
      { key: 'KD', value: 'KD avia' },
      { key: 'IT', value: 'Kingfisher Airlines' },
      { key: 'KL', value: 'KLM' },
      { key: 'KE', value: 'Korean Air' },
      { key: 'LR', value: 'LACSA' },
      { key: 'LA', value: 'LAN Airlines' },
      { key: '4M', value: 'Lan Argentina' },
      { key: 'XL', value: 'LAN Ecuador' },
      { key: 'LP', value: 'LAN Peru' },
      { key: 'LO', value: 'LOT-Polish Airlines' },
      { key: 'LT', value: 'LTU' },
      { key: 'LH', value: 'Lufthansa' },
      { key: 'MH', value: 'Malaysia Airlines' },
      { key: 'MA', value: 'Malev Hungarian Airlines' },
      { key: 'MP', value: 'Martinair Holland' },
      { key: 'MH', value: 'Mexicana' },
      { key: 'NW', value: 'Northwest' },
      { key: 'OA', value: 'Olympic' },
      { key: 'PR', value: 'Philippine Airlines' },
      { key: 'QF', value: 'Qantas Airways' },
      { key: 'QR', value: 'Qatar Airways' },
      { key: 'SK', value: 'SAS' },
      { key: 'SA', value: 'South African Airways' },
      { key: 'JK', value: 'Spanair' },
      { key: 'LY', value: 'Sun Country Airlines' },
      { key: 'LX', value: 'Swiss International Air Lines' },
      { key: 'TA', value: 'TACA' },
      { key: 'JJ', value: 'TAM Brazilian Airlines' },
      { key: 'TP', value: ' TAP Portugal' },
      { key: 'TG', value: 'Thai Air International' },
      { key: 'TK', value: 'Turkish Airlines' },
      { key: 'UA', value: 'United' },
      { key: 'US', value: ' US Airways' },
      { key: 'VA', value: 'V Australia' },
      { key: 'VN', value: 'Vietnam Airlines' },
      { key: 'VX', value: 'Virgin America' },
      { key: 'VS', value: 'Virgin Atlantic' },
      { key: 'WS', value: 'West Jet' },
    ];

    return preferredairline.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public renderAdultCountChange() {
    const adultCount = [
      { key: '1', value: '1 Adult' },
      { key: '2', value: '2 Adults' },
      { key: '3', value: '3 Adults' },
      { key: '4', value: '4 Adults' },
      { key: '5', value: '5 Adults' },
      { key: '6', value: '6 Adults' },
    ];

    return adultCount.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public renderSeniorCountChange() {
    const seniorCount = [
      { key: '0', value: '0 Seniors' },
      { key: '1', value: '1 Seniors' },
      { key: '2', value: '2 Seniors' },
      { key: '3', value: '3 Seniors' },
      { key: '4', value: '4 Seniors' },
      { key: '5', value: '5 Seniors' },
      { key: '6', value: '6 Seniors' },
    ];

    return seniorCount.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public renderNumChild() {
    const numChild = [
      { key: '0', value: '0 Children' },
      { key: '1', value: '1 Child' },
      { key: '2', value: '2 Children' },
      { key: '3', value: '3 Children' },
      { key: '4', value: '4 Children' },
      { key: '5', value: '5 Children' },
      { key: '6', value: '6 Children' },
    ];

    return numChild.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public renderInfantCountChange() {
    const infantCount = [];
    for (let i = 0; i <= 6; i++) {
      if (i === 1) {
        infantCount.push({ key: i, value: `${i} Infant` });
      } else {
        infantCount.push({ key: i, value: `${i} Infants` });
      }
    }

    return infantCount.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public renderFlightClassChange() {
    const flightclasschange = [
      { key: '3', value: 'Economy/Coach' },
      { key: '2', value: 'Business' },
      { key: '1', value: 'First Class' },
    ];

    return flightclasschange.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public renderFlightDirects() {
    const flightdirectchange = [
      { key: '0', value: 'all flights' },
      { key: '1', value: 'non stop only' },
    ];

    return flightdirectchange.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public renderFlightPenalty() {
    const flightpenaltychange = [
      { key: '0', value: 'all flights' },
      { key: '1', value: 'avoid changing penalties' },
    ];

    return flightpenaltychange.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public render() {
    return (
      <>
        <UitkToast onCloseRef={this.onCloseRef} show={this.state.copyStatus} verticalOffset={200}>
          {this.state.copyMessage}
        </UitkToast>
        <span style={{ color: 'red' }}>{this.state.message}</span>
        <UitkSelect onChange={this.onTriptypeChange} id="triptype" label="Type of trip">
          {this.renderTripchange()}
        </UitkSelect>

        <UitkSpacing padding={{ blockstart: 'three', blockend: 'three' }}>
          <UitkHeading tag="h2" size={5}>
            Select your Origin/Destination
          </UitkHeading>
        </UitkSpacing>

        <UitkLayoutGrid columns={2} space="three">
          <UitkLayoutGridItem>
            <div>
              <UitkTypeahead
                adapter={
                  new ESSAdapter({
                    client: 'Homepage',
                    dest: true,
                    domain: 'https://www.expedia.com/',
                    expuserid: -1,
                    features: 'contextual_ta|postal_code|multiregion_parent|ta_hierarchy',
                    guid: '8cbe8b8bee5249e08c293ae5ec40abea', // you can switch this with your own guid but only works if user has serach history
                    lob: 'FLIGHTS',
                    locale: 'en_US',
                    maxResults: 10,
                    personalize: false, // change to true to see recent searches
                    regionType: 2047,
                    siteId: 1,
                  })
                }
                label="Flying From"
                name="flightSourceLocation"
                icon="place"
                onUpdate={this.onSourceLocationChange}
              />
              <span style={{ color: 'red' }}>{this.state.errors['location']}</span>
            </div>
          </UitkLayoutGridItem>

          <UitkLayoutGridItem>
            <div>
              <UitkTypeahead
                adapter={
                  new ESSAdapter({
                    client: 'Homepage',
                    dest: true,
                    domain: 'https://www.expedia.com/',
                    expuserid: -1,
                    features: 'contextual_ta|postal_code|multiregion_parent|ta_hierarchy',
                    guid: '8cbe8b8bee5249e08c293ae5ec40abea', // you can switch this with your own guid but only works if user has serach history
                    lob: 'FLIGHTS',
                    locale: 'en_US',
                    maxResults: 10,
                    personalize: false, // change to true to see recent searches
                    regionType: 2047,
                    siteId: 1,
                  })
                }
                label="Flying To"
                name="flightDestinationLocation"
                icon="place"
                onUpdate={this.onDestinationLocationChange}
              />
            </div>
          </UitkLayoutGridItem>
        </UitkLayoutGrid>
        {this.onTriptypeDatehide()}
        <span style={{ color: 'red' }}>{this.state.errors['dates']}</span>
        <UitkSpacingHr />
        <UitkSpacing padding={{ blockstart: 'three', blockend: 'three' }}>
          <UitkHeading tag="h2" size={5}>
            Who is Travelling ?
          </UitkHeading>
        </UitkSpacing>
        <span style={{ color: 'red' }}>{this.state.errors['infant']}</span>

        <Viewport>
          <ViewLarge>
            <UitkSpacing padding={{ blockend: 'six' }}>
              <UitkLayoutGrid columns={4} space="three">
                <>
                  <UitkLayoutGridItem>
                    <div>
                      <UitkText align="left" size={300} weight="bold">
                        Adults
                      </UitkText>
                      <UitkSelect
                        id="adultCount"
                        label=""
                        icon="person"
                        onChange={this.onAdultCountChange}
                        hasVisibleLabel={false}
                      >
                        {this.renderAdultCountChange()}
                      </UitkSelect>
                    </div>
                  </UitkLayoutGridItem>

                  <UitkLayoutGridItem>
                    <div>
                      <UitkText align="left" size={300} weight="bold">
                        Children (Ages 2-17)
                      </UitkText>
                      <UitkSelect
                        id="numChild"
                        label=""
                        icon="person"
                        onChange={this.onChildCountChange}
                        hasVisibleLabel={false}
                      >
                        {this.renderNumChild()}
                      </UitkSelect>
                      <div>{this.state.childAge}</div>
                    </div>
                  </UitkLayoutGridItem>

                  <UitkLayoutGridItem>
                    <div>
                      <UitkText align="left" size={300} weight="bold">
                        Infants (Age under 2)
                      </UitkText>
                      <UitkSelect
                        id="infantCount"
                        label=""
                        icon="person"
                        onChange={this.onInfantCountChange}
                        hasVisibleLabel={false}
                      >
                        {this.renderInfantCountChange()}
                      </UitkSelect>
                    </div>
                  </UitkLayoutGridItem>
                </>
              </UitkLayoutGrid>
            </UitkSpacing>
          </ViewLarge>

          <ViewSmall>
            <div>
              <UitkSpacing margin={{ blockstart: 'four' }}>
                <UitkText align="left" size={300} weight="bold">
                  Adults
                </UitkText>
              </UitkSpacing>
              <UitkSelect
                id="adultCount"
                label="Adults"
                icon="person"
                onChange={this.onAdultCountChange}
                hasVisibleLabel={false}
              >
                {this.renderAdultCountChange()}
              </UitkSelect>

              <UitkSpacing margin={{ blockstart: 'four' }}>
                <UitkText align="left" size={300} weight="bold">
                  Children (Ages 2-17)
                </UitkText>
              </UitkSpacing>
              <UitkSelect
                id="numChild"
                label=""
                icon="person"
                onChange={this.onChildCountChange}
                hasVisibleLabel={false}
              >
                {this.renderNumChild()}
              </UitkSelect>

              <div>{this.state.childAge}</div>

              <UitkSpacing margin={{ blockstart: 'four' }}>
                <UitkText align="left" size={300} weight="bold">
                  Infants (Age under 2)
                </UitkText>
              </UitkSpacing>
              <UitkSelect
                id="infantCount"
                label=""
                icon="person"
                onChange={this.onInfantCountChange}
                hasVisibleLabel={false}
              >
                {this.renderInfantCountChange()}
              </UitkSelect>
            </div>
          </ViewSmall>
        </Viewport>

        <UitkSpacingHr />

        <div>
          <UitkHeading tag="h2" size={5}>
            Are there any more Details
          </UitkHeading>
        </div>

        <div>
          <UitkSelect onChange={this.onAirlineChange} id="preferredairline" label="Preferred Airline">
            {this.renderPreferredAirline()}
          </UitkSelect>
        </div>

        <div>
          <Viewport>
            <ViewLarge>
              <UitkSpacing padding={{ blockstart: 'three' }}>
                <UitkLayoutGrid columns={4} space="three">
                  <>
                    <UitkLayoutGridItem>
                      <div>
                        <UitkSelect
                          icon="lob_flights"
                          onChange={this.onFlightClassChange}
                          id="flightclasschange"
                          label="Class"
                        >
                          {this.renderFlightClassChange()}
                        </UitkSelect>
                      </div>
                    </UitkLayoutGridItem>

                    <UitkLayoutGridItem>
                      <div>
                        <UitkSelect
                          icon="lob_flights"
                          onChange={this.onFlightDirects}
                          id="flightdirectchange"
                          label="Direct"
                        >
                          {this.renderFlightDirects()}
                        </UitkSelect>
                      </div>
                    </UitkLayoutGridItem>

                    <UitkLayoutGridItem>
                      <div>
                        <UitkSelect
                          icon="lob_flights"
                          onChange={this.onFlightPenalty}
                          id="flightpenaltychange"
                          label="No Change Penalty"
                        >
                          {this.renderFlightPenalty()}
                        </UitkSelect>
                      </div>
                    </UitkLayoutGridItem>
                  </>
                </UitkLayoutGrid>
              </UitkSpacing>
            </ViewLarge>

            <ViewSmall>
              <UitkSpacing padding={{ blockstart: 'three' }}>
                <>
                  <UitkSpacing padding={{ blockstart: 'three', blockend: 'three' }}>
                    <div>
                      <UitkSelect
                        icon="lob_flights"
                        onChange={this.onFlightClassChange}
                        id="flightclasschange"
                        label="Class"
                      >
                        {this.renderFlightClassChange()}
                      </UitkSelect>
                    </div>
                  </UitkSpacing>

                  <UitkSpacing padding={{ blockend: 'three' }}>
                    <div>
                      <UitkSelect
                        icon="lob_flights"
                        onChange={this.onFlightDirects}
                        id="flightdirectchange"
                        label="Direct"
                      >
                        {this.renderFlightDirects()}
                      </UitkSelect>
                    </div>
                  </UitkSpacing>

                  <UitkSpacing padding={{ blockend: 'three' }}>
                    <div>
                      <UitkSelect
                        icon="lob_flights"
                        onChange={this.onFlightPenalty}
                        id="flightpenaltychange"
                        label="No Change Penalty"
                      >
                        {this.renderFlightPenalty()}
                      </UitkSelect>
                    </div>
                  </UitkSpacing>
                </>
              </UitkSpacing>
            </ViewSmall>
          </Viewport>
        </div>

        <UitkSpacing margin={{ block: 'three' }}>
          <UitkPrimaryButton name="buildlink" type="button" onClick={this.handleClick} isFullWidth={true}>
            Build Deeplink
          </UitkPrimaryButton>
        </UitkSpacing>

        <div>
          <UitkText align="left" size={500} weight="bold">
            Here is your Deeplink
          </UitkText>
          {this.state.isLoading ? (
            <Loader />
          ) : (
            <UitkTextArea id="deeplink_holder" label="" name="deeplink_holder" value={this.state.link} />
          )}
        </div>

        <UitkSpacing margin={{ block: 'three' }}>
          <div>
            <UitkLayoutFlex space="three">
              <>
                <UitkPrimaryButton name="buildlink" type="button" onClick={this.copyToClipBoard}>
                  Copy Link
                </UitkPrimaryButton>

                <UitkPrimaryButton name="buildlink" type="button" onClick={this.handleUrlOpen}>
                  Test Link
                </UitkPrimaryButton>
              </>
            </UitkLayoutFlex>
          </div>
        </UitkSpacing>
      </>
    );
  }

  public componentWillUnMount() {
    setTimeout(() => this.setState({ message: '' }), 3000);
  }
  public componentDidUpdate() {
    setTimeout(() => this.setState({ copyStatus: false }), 4000);
  }
}
